// extracted by mini-css-extract-plugin
export default {"header":"styles_header__4ZYnh","main":"styles_main__CZwCt","main_group":"styles_main_group__qqRsn"};